import React, { Component } from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ModalComponent } from "../modal";
import { ModalTemplate } from "../modalTemplate";
import CloseIcon from "../../../assets/Escalation-Closebtn.svg";
import Level1Image from "../../../assets/level1_mod.png";
// import Level1Image from "../../../assets/Level1.png"
import Level2Image from "../../../assets/Level2.png";
import Level3Image from "../../../assets/Level3.png";
import Level4Image from "../../../assets/Level4.png";
import Level5Image from "../../../assets/Level5.png";
import Level6Image from "../../../assets/level-6.png";
import { RedirectUser } from "../redirectUser";
import { LoaderPage } from "../../../component/Loader";
import { getEscalationHistory } from "../../../services/apiServices";
import request from "../../../services/requestService";
import { escalationTimeFormat } from "../../../helper";

export class EscalationLevelModal extends Component {
  state = {
    modalOpen: false,
    isLoading: false,
    escalationHistoryData: [],
    pragatiDetailPage: true
  };
  handleOpenModal = async () => {
    const { IssueId, pragatiDetailPage } = this.props;
    const response = await request(getEscalationHistory(IssueId));
    this.setState({
      isLoading: true,
      escalationHistoryData: response.data.data,
      pragatiDetailPage: false
    });
    setTimeout(() => {
      this.setState({
        isLoading: false,
        modalOpen: true,
        pragatiDetailPage: pragatiDetailPage
      });
    }, 1500);
  };
  onClose = () => {
    this.setState({ modalOpen: false });
  };
  getMarginLeft = selectedValue => {
    const level = selectedValue;
    switch (level) {
      case "Level 01: PMG":
        return "1.6em";
      case "Level 02: Secretary, DPIIT":
        return "-0.6em";
      case "Level 03: Cabinet Secretariat":
        return "-1.4em";
      case "Level 04: Monitoring Group, PMO":
        return "-2.2em";
      case "Level 05: Pragati, PM":
        return "0.2em";
      case "Level 0: Ministry Review":
        return "0.2em";
    }
  };
  getClassName = selectedValue => {
    const level = selectedValue;
    switch (level) {
      case "Level 01: PMG":
        return "level1-pmg-text";
      case "Level 02: Secretary, DPIIT":
        return "level2-text";
      case "Level 03: Cabinet Secretariat":
        return "level3-text";
      case "Level 04: Monitoring Group, PMO":
        return "level4-text";
      case "Level 05: Pragati, PM":
        return "level5-text";
      case "Level 0: Ministry Review":
        return "level6-text";
    }
  };
  getPyramidImg = selectedValue => {
    const level = selectedValue;
    switch (level) {
      case "Level 01: PMG":
        return Level1Image;
      case "Level 02: Secretary, DPIIT":
        return Level2Image;
      case "Level 03: Cabinet Secretariat":
        return Level3Image;
      case "Level 04: Monitoring Group, PMO":
        return Level4Image;
      case "Level 05: Pragati, PM":
        return Level5Image;
      case "Level 0: Ministry Review":
        return Level6Image;
    }
  };
  convertTimestampToDateTime(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date
      .getDate()
      .toString()
      .padStart(2, "0");
    const [hours, minutes] = escalationTimeFormat(timestamp).split(":");
    const formattedHours = hours.padStart(2, "0");
    //console.log(escalationTimeFormat(timestamp));
    const formattedDateTime = `${day}/${month}/${year}, ${formattedHours}:${minutes}`;
    return formattedDateTime;
  }
  render() {
    const {
      modalOpen,
      isLoading,
      escalationHistoryData,
      pragatiDetailPage
    } = this.state;
    const { EscalationName, pragatiDetailPageCss } = this.props;
    const showHistory =
      (escalationHistoryData.length > 1 &&
        EscalationName == "Level 0: Ministry Review") ||
      EscalationName != "Level 0: Ministry Review";
    return (
      <>
        <OverlayTrigger
          trigger="hover"
          placement="bottom"
          defaultShow={false}
          overlay={
            <Tooltip
              id={`tooltip-checking`}
              className="escalation-level-modal-tolltip"
              style={{
                marginLeft: this.getMarginLeft(EscalationName)
              }}
            >
              Escalation Level
            </Tooltip>
          }
        >
          <span
            className={this.getClassName(EscalationName)}
            onClick={this.handleOpenModal}
            style={{
              textTransform: pragatiDetailPageCss ? "capitalize" : null
            }}
          >
            {EscalationName}
          </span>
        </OverlayTrigger>
        {modalOpen ? (
          <ModalComponent
            centered={true}
            containerClass={`nodal-officer-popup comment-modal-body escalation-level-modal projectnote-modal
              ${
                EscalationName == "Level 0: Ministry Review" &&
                escalationHistoryData.length <= 1
                  ? "modal-zero-escalation"
                  : EscalationName == "Level 0: Ministry Review"
                  ? "zero-escalation-data"
                  : ""
              }`}
            isLoading={true}
            hideProgressbar={true}
            onClose={this.onClose}
            template={
              <ModalTemplate
                bodyTemplate={
                  <>
                    <div
                      className="escalation-history-text-div"
                      style={{
                        marginRight:
                          EscalationName == "Level 0: Ministry Review"
                            ? 0
                            : "-2.8em"
                      }}
                    >
                      <h4>
                        Escalation History
                        <Image src={CloseIcon} onClick={this.onClose} />
                      </h4>
                    </div>
                    <div className="row">
                      <div
                        className={`col-md-${
                          escalationHistoryData.length <= 1 &&
                          EscalationName == "Level 0: Ministry Review"
                            ? 12
                            : 6
                        }`}
                      >
                        <Image
                          src={this.getPyramidImg(EscalationName)}
                          className="escalation-level-pyramid"
                        />
                      </div>
                      {showHistory && (
                        <div
                          className="col-md-6"
                          style={{
                            marginTop: "2.9em",
                            paddingLeft: 17,
                            height: "20em",
                            //escalationHistoryData.length >= 5 ? "20em" : null,
                            overflowY: "auto",
                            //escalationHistoryData.length >= 5 ? "scroll" : null,
                            marginBottom:
                              escalationHistoryData.length >= 5 ? "1em" : null
                          }}
                        >
                          {escalationHistoryData.map(e => (
                            <div
                              style={{ lineHeight: "17px", marginBottom: 10 }}
                            >
                              <span
                                style={{ fontFamily: "mpsb", color: "#525252" }}
                              >
                                {this.convertTimestampToDateTime(e.date)} |
                              </span>{" "}
                              <RedirectUser
                                title={e.assignedTo}
                                id={e.assignedToUserId}
                                escalationlevelcss={true}
                              />{" "}
                              <span
                                style={{ fontFamily: "mpsb", color: "#E75521" }}
                              >
                                ({e.assignedToGroup})
                              </span>
                              <br />
                              <span
                                style={{ fontFamily: "mpsb", marginTop: 3 }}
                              >
                                Escalation {e.escalationLevel[0]}
                              </span>
                              <br />
                              <span
                                style={{
                                  fontFamily: "mpsb",
                                  marginTop: 3,
                                  display: e.reason[0] == null ? "none" : null
                                }}
                              >
                                Reason:
                              </span>{" "}
                              <span
                                style={{
                                  fontFamily: "mpr",
                                  wordWrap: "break-word"
                                }}
                              >
                                {e.reason[0]}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                }
                modalFooterHide={true}
                headerDisplay={false}
              />
            }
          />
        ) : null}
        {pragatiDetailPage ? null : <LoaderPage loading={isLoading} />}
      </>
    );
  }
}
